import { APICore } from './apiCore'

const api = new APICore()

function getRangos (params) {
  const baseUrl = '/rangos-edad'
  return api.get(baseUrl, params)
}

function getRango (id) {
  const baseUrl = `/rangos-edad/${id}`
  return api.get(baseUrl, {})
}

function addRango (params) {
  const baseUrl = '/rangos-edad'
  return api.create(baseUrl, params)
}

function updateRango (params) {
  const baseUrl = '/rangos-edad'
  return api.update(baseUrl, params)
}

function updateRangos (params) {
  const baseUrl = '/rangos-edad/order'
  return api.update(baseUrl, params)
}

function deleteRango (params) {
  const baseUrl = '/rangos-edad'
  return api.delete(baseUrl, params)
}

export { getRangos, getRango, addRango, updateRango, updateRangos, deleteRango }
